const routes = [
  {
    index: true,
    label: 'Axe AI',
    path: '/',
  },
];

export default routes;
